//  import React from "react";

// const FeesStructure = () => {
// return (
// <div style={{ height: "100vh" }}>
 
//   <iframe
//     src="/fees.pdf"
//     width="100%"
//     height="100%"
//     title="Fees PDF"
//     style={{ border: "none" }}
//   />

// </div>
 

// );
// };

// export default FeesStructure;
 import React from "react";

const FeesStructure = () => {
return ( <div style={styles.container}>

```
  {/* 🔥 Header */}
  <div style={styles.header}>
    <h2 style={styles.title}>📄 Mandatory Disclosure</h2>

    <a
      href="/uploads/images/1777103468_69ec726c7845a.jpg"
      target="_blank"
      rel="noopener noreferrer"
      style={styles.downloadBtn}
    >
      🔍 Open
    </a>
  </div>

  {/* 🔥 Image Viewer */}
  <div style={styles.viewer}>
    <img
      src="https://dpsladwa.com/Dpsschool_Data/uploads/images/1777103468_69ec726c7845a.jpg"
      alt="Fees Structure"
      style={styles.image}
    />
  </div>

</div>
 

);
};

const styles = {
container: {
width: "100%",
height: "100vh",
display: "flex",
flexDirection: "column",
background: "#f5f6fa",
 
},

header: {
height: "60px",
padding: "0 20px",
background: "#1e293b",
color: "#fff",
display: "flex",
justifyContent: "space-between",
alignItems: "center",
},

title: {
margin: 0,
fontSize: "18px",
},

downloadBtn: {
background: "#3b82f6",
color: "#fff",
padding: "8px 14px",
borderRadius: "6px",
textDecoration: "none",
},

viewer: {
height: "calc(100vh - 60px)",
width: "100%",
display: "flex",
justifyContent: "center",
alignItems: "center",
background: "#fbf3f3ff",
},

image: {
maxWidth: "100%",
maxHeight: "80%",
objectFit: "contain", // ✅ pura image dikhegi (crop nahi hogi)
marginTop:50
},
};

export default FeesStructure;
